import type { MinimalFeaturesQueryResult } from '@app/sanity.types';
import { getAppConfiguration } from '@utils/browserEnv';
import { Menu } from 'antd';
import Link from 'next/link';
import { stegaClean } from 'next-sanity';
import type { FC } from 'react';
import { SanityImage } from 'sanity-image';

const { projectId, dataset } = getAppConfiguration();

export function FeaturesMenuItems(items: MinimalFeaturesQueryResult) {
  return items.map((item) => ({
    key: item.slug.current,
    icon: item.icon?.asset?._ref ? (
      <SanityImage
        id={stegaClean(item.icon.asset._ref)}
        projectId={projectId}
        dataset={dataset}
        width={20}
        height={20}
        alt={item.title}
      />
    ) : undefined,
    label: <Link href={`/features/${item.slug.current}`}>{item.title}</Link>,
    style: { minWidth: '220px', display: 'flex', alignItems: 'center' },
  }));
}

interface FeaturesMenuProps {
  items: MinimalFeaturesQueryResult;
}

const FeaturesMenu: FC<FeaturesMenuProps> = ({ items }) => {
  const menuItems = FeaturesMenuItems(items);
  return <Menu items={menuItems} />;
};

export default FeaturesMenu;
